import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { MVMSpinnerBtnModule } from '../../../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../../../shared/pipes/shared-pipes.module';
import { CustomerPipeModule } from '../../shared/pipes/customer-pipe.module';
import { CustomerDetailsModalComponent } from './individual-customer-details-modal.component';
import { IndividualCustomerDetailsComponent } from './individual-customer-details.component';

@NgModule({
    declarations: [
        IndividualCustomerDetailsComponent,
        CustomerDetailsModalComponent
    ],
    providers: [],
    imports: [
        CalendarModule,
        CommonModule,
        CustomerPipeModule,
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SharedPipesModule,
        TableModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerDetailsModalComponent,
        IndividualCustomerDetailsComponent
    ]
})
export class IndividualCustomerDetailsModule {
}
